import Constant from '@/const';
import axios from 'axios';

const getOrderHistoryByIdEmr = async ({ idEmr, params }) => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/supportservice/laboratory/history/${idEmr}`),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getOrderHistoryByIdEmr;
